import resourceFactory from "common/admin/resourceFactory";

const actions = resourceFactory("food_supplier_master");

export default actions;
